import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';

import { Template } from '../models/Template';
import { SenderDomain } from '../models';

@Injectable()
export class EmailService {
  private readonly backofficeUrl = `${this.emailBaseUrl}backoffice/`;
  private readonly bootstrapUrl = `${this.emailBaseUrl}bootstrap/`;

  constructor(
    private readonly http: HttpClient,
    @Inject('emailBaseUrl') private emailBaseUrl: string,
  ) {}

  fetchTemplates(accountId: string) {
    return this.http.get<Template[]>(
      `${this.backofficeUrl}accounts/${accountId}/activities/type/template`,
    );
  }

  copyTemplate(templateId: string, toAccountId: string, fromAccountId: string) {
    return this.http.post(
      `${this.backofficeUrl}accounts/${toAccountId}/activities/template/${templateId}/clone`,
      { templateAccountId: fromAccountId },
    );
  }

  reBootstrapByAccount(accountId: string) {
    return this.http.put(`${this.bootstrapUrl}accounts`, `"${accountId}"`, {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    });
  }

  reBootstrapAllAccounts() {
    return this.http.get(`${this.bootstrapUrl}accounts`);
  }

  fetchSenderDomains(accountId: string) {
    return this.http.get<SenderDomain[]>(
      `${this.backofficeUrl}sender-domains/account/${accountId}`,
    );
  }

  createSenderDomain(
    accountId: string,
    fromDomain: string,
    senderDomain: string,
  ) {
    return this.http.post<SenderDomain>(
      `${this.backofficeUrl}sender-domains/manager`,
      { accountId, fromDomain, senderDomain },
    );
  }

  deleteSenderDomain(domainId: string, accountId: string) {
    return this.http.delete(
      `${this.backofficeUrl}sender-domains/account/${accountId}/${domainId}`,
    );
  }
}
